// Navigation Actions
export const openUserMenu = customerDetails => ({
  type: "OPEN_USER_MENU",
})

export const closeUserMenu = customerDetails => ({
  type: "CLOSE_USER_MENU",
})

// example intakes "account" | "savedlists" | "orders"
export const dashboardOpeningState = dashboardOpeningState => ({
  type: "DASHBOARD_OPENING_STATE",
  dashboardOpeningState,
})
